import produce from 'immer';

import {
  CREATE_DEPARTMENT_FAILURE,
  CREATE_DEPARTMENT_SUCCESS,
  EDIT_DEPARTMENT_FAILURE,
  EDIT_DEPARTMENT_SEQUENCE_FAILURE,
  EDIT_DEPARTMENT_SEQUENCE_SUCCESS,
  EDIT_DEPARTMENT_SUCCESS,
  FETCH_DEPARTMENT_FAILURE,
  FETCH_DEPARTMENT_LIST_FAILURE,
  FETCH_DEPARTMENT_LIST_SUCCESS,
  FETCH_DEPARTMENT_SUCCESS,
} from '@actions/department';

const initialState: IDepartmentStore = {
  departments: null,
  currentDepartment: null,
  error: null,
};

export default (state: IDepartmentStore = initialState, action: any) =>
  produce(state, (draftState: IDepartmentStore) => {
    switch (action.type) {
      case CREATE_DEPARTMENT_SUCCESS:
      case FETCH_DEPARTMENT_LIST_SUCCESS:
      case EDIT_DEPARTMENT_SEQUENCE_SUCCESS:
      case EDIT_DEPARTMENT_SUCCESS:
        draftState.departments = action.response;
        draftState.error = null;

        return;

      case FETCH_DEPARTMENT_SUCCESS:
        draftState.currentDepartment = action.response;
        draftState.error = null;

        return;

      case CREATE_DEPARTMENT_FAILURE:
      case FETCH_DEPARTMENT_LIST_FAILURE:
      case EDIT_DEPARTMENT_SEQUENCE_FAILURE:
      case EDIT_DEPARTMENT_FAILURE:
      case FETCH_DEPARTMENT_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
